import { readCookie, createCookie } from "../utils/helpers";
import { LOCALE } from "./constants";
const currentEnv = `${process.env.REACT_APP_ENVIRONMENT}`;

// export const getTenantId = () => {
//   const tenantId = {
//     QA: "7fc9f425-1463-4a8e-8556-6c6b34cfcff6",
//     PRODUCTION: "F583361C-4EE9-485C-9CBC-2F83DE7020C1",
//     STAGING: "F583361C-4EE9-485C-9CBC-2F83DE7020C1",
//     DEVELOPMENT: "7fc9f425-1463-4a8e-8556-6c6b34cfcff6",
//   };
//   return tenantId[currentEnv];
// };

// export const getTenantGroupId = () => {
//   const tenantGroupId = {
//     PRODUCTION: "9C7D9766-9EBF-47A4-94E6-3F1F50CD4B2F",
//     STAGING: "9C7D9766-9EBF-47A4-94E6-3F1F50CD4B2F",
//     QA: "580C8B5A-DB83-4834-14EF-08D9501E735D",
//     DEVELOPMENT: "580C8B5A-DB83-4834-14EF-08D9501E735D",
//   };
//   return tenantGroupId[currentEnv];
// };

// export const getTenantGroupId = () => {
//   let tenantGroupId = {};
//   let domain = currentDomain();
//   switch (domain?.toLowerCase()) {
//     case DomainName.RESUMEBUILD:
//       tenantGroupId = {
//         PRODUCTION: "9C7D9766-9EBF-47A4-94E6-3F1F50CD4B2F",
//         STAGING: "9C7D9766-9EBF-47A4-94E6-3F1F50CD4B2F",
//         QA: "580C8B5A-DB83-4834-14EF-08D9501E735D",
//         DEVELOPMENT: "580C8B5A-DB83-4834-14EF-08D9501E735D",
//       };
//       break;
//     case DomainName.QUICKWERX:
//       tenantGroupId = {
//         QA: "AAD7AC69-E7DA-45B3-B97C-EA2036616DD5",
//         PRODUCTION: "AAD7AC69-E7DA-45B3-B97C-EA2036616DD5",
//         STAGING: "AAD7AC69-E7DA-45B3-B97C-EA2036616DD5",
//         DEVELOPMENT: "AAD7AC69-E7DA-45B3-B97C-EA2036616DD5",
//       };
//       break;
//     default:
//       console.log("default tenant");
//       tenantGroupId = {
//         PRODUCTION: "9C7D9766-9EBF-47A4-94E6-3F1F50CD4B2F",
//         STAGING: "9C7D9766-9EBF-47A4-94E6-3F1F50CD4B2F",
//         QA: "580C8B5A-DB83-4834-14EF-08D9501E735D",
//         DEVELOPMENT: "580C8B5A-DB83-4834-14EF-08D9501E735D",
//       };
//       break;
//   }
//   return tenantGroupId[currentEnv];
// };

export const getTenantId = () => {
  let getTenantId = {};

  getTenantId = {
    PRODUCTION: "3FA85F64-5717-4562-B3FC-2C963F66AFA6",
    STAGING: "3FA85F64-5717-4562-B3FC-2C963F66AFA6",
    QA: "3FA85F64-5717-4562-B3FC-2C963F66AFA6",
    DEVELOPMENT: "3FA85F64-5717-4562-B3FC-2C963F66AFA6",
  };

  return getTenantId[currentEnv];
};

export const getGoogleClientId = () => {
  return "852323210304-eqqqsnsgjh920e8b9oo767vi9lj1jsvm.apps.googleusercontent.com";
};

export const getFacebookClientId = () => {
  return "237961018547564";
};

export const getServiceCodeForgotPwd = () => {
  return "SRVRGR";
};

export const proIPKey = () => {
  return "xEpnPQEFi9Wy07q";
};
export const ip2LocationKey = "BCD0D9257EBF1734C2257D1E3173B29A";

export const TrustPilotKey = () => {
  return "k57tr84bd96sp32xg63oc47em85if29q";
};
export const userGuid = () => {
  let userguid = readCookie("userguid");
  if (!!userguid) {
    return userguid.toLocaleLowerCase();
  } else {
  }
};

export const hidePaypal = (currencyCD) => {
  let isHide = false;
  const currenciesToHide = "ZAR|TRY|MYR|SAR|AED";
  if (currenciesToHide.split("|").includes(currencyCD)) {
    isHide = true;
  }
  return isHide;
};

export const getService = () => {
  const ServiceId = {
    QA: "BBCF66C5-D049-4EE6-98B9-AEF39E854D23",
    PRODUCTION: "F583361C-4EE9-485C-9CBC-2F83DE7020C1",
    STAGING: "F583361C-4EE9-485C-9CBC-2F83DE7020C1",
    DEVELOPMENT: "BBCF66C5-D049-4EE6-98B9-AEF39E854D23",
  };
  return ServiceId[currentEnv];
};
export const getServiceCode = () => {
  const ServiceCode = {
    QA: "SRVRGR",
    PRODUCTION: "SRVRGR",
    STAGING: "SRVRGR",
    DEVELOPMENT: "SRVRGR",
  };
  return ServiceCode[currentEnv];
};

export const getGoogleDriveClientId = () => {
  let gDriveId =
    "448279941363-0as5am8vori1vf6nk02n488cne8a5c1j.apps.googleusercontent.com";
  return gDriveId;
};

export const getGoogleDriveDeveloperKey = () => {
  let gDriveDeveloperKey = "AIzaSyA3bZ601DpfNdDQyUADbns8hpqbXpJZAoA";

  return gDriveDeveloperKey;
};

export const getDropboxAppKey = () => {
  return "zn24myb1flq9r5t";
};
export const getResumeBuildOneDriveClientID = () => {
  return "7b430211-4602-4943-91d5-1033a5717768"; //App Name - PDFSimpli-onedrive
};
export const blobSignature = () => {
  const blobSign = {
    QA: "?sv=2020-04-08&si=pdfsimpliuserstest&sr=c&sig=C5E6T6kNLW0pcWAW2l2KrY1pboKjZQh1IhO%2FP9iozO8%3D",
    PRODUCTION:
      "?sv=2017-04-17&si=pdfsimpliusers&sr=c&sig=tLI3WycMdpg2v5sTxxX1RVi22y9Hz6tI8eeyOriK%2BjE%3D",
    STAGING:
      "?sv=2017-04-17&si=pdfsimpliusers&sr=c&sig=tLI3WycMdpg2v5sTxxX1RVi22y9Hz6tI8eeyOriK%2BjE%3D",
    DEVELOPMENT:
      "?sv=2020-04-08&si=pdfsimpliuserstest&sr=c&sig=C5E6T6kNLW0pcWAW2l2KrY1pboKjZQh1IhO%2FP9iozO8%3D",
  };
  return blobSign[currentEnv];
};
export const imageBlobSignature = () => {
  const imageBlobSign = {
    QA: "?sv=2020-04-08&si=pdfsimpliuserstest&sr=c&sig=C5E6T6kNLW0pcWAW2l2KrY1pboKjZQh1IhO%2FP9iozO8%3D",
    PRODUCTION:
      "?sv=2017-04-17&si=pdfsimpliusers&sr=c&sig=tLI3WycMdpg2v5sTxxX1RVi22y9Hz6tI8eeyOriK%2BjE%3D",
    STAGING:
      "?sv=2017-04-17&si=pdfsimpliusers&sr=c&sig=tLI3WycMdpg2v5sTxxX1RVi22y9Hz6tI8eeyOriK%2BjE%3D",
    DEVELOPMENT:
      "?sv=2020-04-08&si=pdfsimpliuserstest&sr=c&sig=C5E6T6kNLW0pcWAW2l2KrY1pboKjZQh1IhO%2FP9iozO8%3D",
  };
  return imageBlobSign[currentEnv];
};
export const getAnonymousUserToken = () => {
  const anonymousUserToken = {
    QA: "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsInRva2VuX3R5cGUiOjEwLCJraWQiOiI0NGUwZmY2MzgwY2E0YzhkOWFlNzBjMjExMjc5NGFiNyJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6IlZpdmVrIiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvc2lkIjoiNzBiNWZiMjAtMGQ1Mi00ZWM1LTgyOGQtNTQxNTkzMmJlMzI5IiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9ncm91cHNpZCI6ImQ2Y2FjYjYxLWM5NTktNDRkNC1iN2E3LWMyYzAwOWIyMzYzNSIsIm5iZiI6MTY1NzAwNjk4NiwiZXhwIjoxOTcyMzY2OTg2LCJpc3MiOiJMZWdhbFNpbXBsaSIsImF1ZCI6IlBERlNpbXBsaSJ9.Qan8dbl9yEHMwzGK1L4yk6FPZH7YpKnBRWYKoH9AyeCSXMmu_G3AVZZAPqcdZaSkf-B5U2RB6eHPz0LRA829FPVgw9r9-ouvu0JUcXNVVHptZ6Pv9btVpgVJ7gVOXrs995_iCtgfJoJqYYhW-mdF0RbjCgFdXmSEaqFTvDRKwDGFQ5JhoELd5-Dcvb3pcfTGuZ98T5K5jJd7dOp3Tj4FPrCijvV8pc3C70mFcwwfNSSi39Dd0e9dQ6yC35qG50bXGxq-CeUyV_BLKsReBSLEe5OnQzvjrIozHFDtmLFfr1qdVWKDMsyis0X-CeminHDeO1QIwJVEaAgcjfXjT_EILw",
    PRODUCTION:
      "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsInRva2VuX3R5cGUiOjEwLCJraWQiOiI2NzM5MWEyMWVlMDU0NzJhYjEzM2NkNzA4ZWM4MDQ4ZiJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6IlZpdmVrIiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvc2lkIjoiYjU0MDA4NDgtNzU1OS00OWM0LWIwMDEtODFiMGYyNDUxNGRlIiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9ncm91cHNpZCI6ImEwMWZkOGMxLWRjZGEtNDczYi04NWNiLWVjYTcwOThmNWI2OSIsIm5iZiI6MTY1NzA4NDg4OCwiZXhwIjoxOTcyNDQ0ODg4LCJpc3MiOiJMZWdhbFNpbXBsaSIsImF1ZCI6IlBERlNpbXBsaSJ9.Je085mV9UuwHSCAHHuPzZB0mQPRoQKfbA7gDhOuWOtVhj9Spl8zp6-8DNgOpbyBv-9G5HhBe0ezgjJEzHtOtM_ZRGvBLpqROvKGnhGBmqVwsiikbxG-f4x3MJe-jXTrsn1M24a9FOOtNRbK9gC1m_wsQZlIoQvkv15--X4ZmyqA-dxLxcFIoEH52q6QzZinWQ1o-ojxM9PRnthhQ4ycdqa6kI1dIilLWXMcpxZ1P7_wKPGRm1kBECNFbM_278SMsa1Cix6MDKoQg6TAiD-hffa-n9omTc8UVmwi3eXs8Rseo8mlTZHCm4rUuyufwniXZ3kX5BXFUTpgbN4voS4_q6w",
    STAGING:
      "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsInRva2VuX3R5cGUiOjEwLCJraWQiOiI2NzM5MWEyMWVlMDU0NzJhYjEzM2NkNzA4ZWM4MDQ4ZiJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6IlZpdmVrIiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvc2lkIjoiYjU0MDA4NDgtNzU1OS00OWM0LWIwMDEtODFiMGYyNDUxNGRlIiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9ncm91cHNpZCI6ImEwMWZkOGMxLWRjZGEtNDczYi04NWNiLWVjYTcwOThmNWI2OSIsIm5iZiI6MTY1NzA4NDg4OCwiZXhwIjoxOTcyNDQ0ODg4LCJpc3MiOiJMZWdhbFNpbXBsaSIsImF1ZCI6IlBERlNpbXBsaSJ9.Je085mV9UuwHSCAHHuPzZB0mQPRoQKfbA7gDhOuWOtVhj9Spl8zp6-8DNgOpbyBv-9G5HhBe0ezgjJEzHtOtM_ZRGvBLpqROvKGnhGBmqVwsiikbxG-f4x3MJe-jXTrsn1M24a9FOOtNRbK9gC1m_wsQZlIoQvkv15--X4ZmyqA-dxLxcFIoEH52q6QzZinWQ1o-ojxM9PRnthhQ4ycdqa6kI1dIilLWXMcpxZ1P7_wKPGRm1kBECNFbM_278SMsa1Cix6MDKoQg6TAiD-hffa-n9omTc8UVmwi3eXs8Rseo8mlTZHCm4rUuyufwniXZ3kX5BXFUTpgbN4voS4_q6w",
    DEVELOPMENT:
      "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsInRva2VuX3R5cGUiOjEwLCJraWQiOiI0NGUwZmY2MzgwY2E0YzhkOWFlNzBjMjExMjc5NGFiNyJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6IlZpdmVrIiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvc2lkIjoiNzBiNWZiMjAtMGQ1Mi00ZWM1LTgyOGQtNTQxNTkzMmJlMzI5IiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9ncm91cHNpZCI6ImQ2Y2FjYjYxLWM5NTktNDRkNC1iN2E3LWMyYzAwOWIyMzYzNSIsIm5iZiI6MTY1NzAwNjk4NiwiZXhwIjoxOTcyMzY2OTg2LCJpc3MiOiJMZWdhbFNpbXBsaSIsImF1ZCI6IlBERlNpbXBsaSJ9.Qan8dbl9yEHMwzGK1L4yk6FPZH7YpKnBRWYKoH9AyeCSXMmu_G3AVZZAPqcdZaSkf-B5U2RB6eHPz0LRA829FPVgw9r9-ouvu0JUcXNVVHptZ6Pv9btVpgVJ7gVOXrs995_iCtgfJoJqYYhW-mdF0RbjCgFdXmSEaqFTvDRKwDGFQ5JhoELd5-Dcvb3pcfTGuZ98T5K5jJd7dOp3Tj4FPrCijvV8pc3C70mFcwwfNSSi39Dd0e9dQ6yC35qG50bXGxq-CeUyV_BLKsReBSLEe5OnQzvjrIozHFDtmLFfr1qdVWKDMsyis0X-CeminHDeO1QIwJVEaAgcjfXjT_EILw",
  };
  return anonymousUserToken[currentEnv];
};

export const determineTraitLevel = (score) => {
  // Determine the level based on score
  if (score > 6.25) return "3"; // High
  if (score > 4.75) return "2"; // Mid/Normal
  return "1"; // Moderate
};

export const removeWhitespace = (text, replacement = "") => {
  return text ? text.replace(/\s+/g, replacement) : "";
};

export const wrapScoresWithTraitLevel = (userTraits) => {
  return userTraits.map((item) => ({
    score: determineTraitLevel(item.score),
    title: item.trait.title,
  }));
};

export const generateContentKey = (mappedUserTrait) => {
  if (mappedUserTrait.length === 0) return "";

  // Create an object to store the scores for each trait
  const scoreMap = {};

  // Populate the scoreMap based on the input
  mappedUserTrait.forEach((item) => {
    const trait = item.title;
    const score = item.score;

    // For each trait, add the corresponding score
    scoreMap[trait] = score;
  });

  // Build the result string for the traits in the correct order
  const resultTraits = [
    scoreMap["E"] ? "E" : "I", // Choose E if present, otherwise I
    scoreMap["S"] ? "S" : "N", // Choose S if present, otherwise N
    scoreMap["T"] ? "T" : "F", // Choose T if present, otherwise F
    scoreMap["J"] ? "J" : "P", // Choose J if present, otherwise P
  ].join("");

  // Build the score string for the same order
  const resultScores = [
    scoreMap["E"] || scoreMap["I"], // Use the score for E or I
    scoreMap["S"] || scoreMap["N"], // Use the score for S or N
    scoreMap["T"] || scoreMap["F"], // Use the score for T or F
    scoreMap["J"] || scoreMap["P"], // Use the score for J or P
  ].join("");
  return `${resultTraits}_${resultScores}`;
};

export const enneagramRank = {
  theadvocate: 1,
  thecollaborator: 2,
  theentrepreneur: 3,
  themaverick: 4,
  theinspector: 5,
  thestalwart: 6,
  theadmirer: 7,
  thedefier: 8,
  themediator: 9,
};

export const CareerPreferenceRank = {
  healthcare_and_medicine: 1,
  information_technology_it_and_software: 2,
  administration_and_management: 3,
  manufacturing: 4,
  legal_services: 5,
  banking_and_finance: 7,
  engineering: 8,
  trades_and_construction: 8,
  government: 9,
  sales: 10,
  transportation_and_logistics: 11,
  education: 12,
  research_and_science: 13,
  pharmaceutical: 14,
  marketing_and_public_relations: 15,
  human_resources: 16,
  food_and_beverage: 17,
  agriculture: 18,
  telecommunications: 19,
  architecture: 20,
  security_and_investigations: 21,
  hospitality_and_tourism: 22,
  media_and_communications: 23,
  automotive: 24,
  art_and_design: 25,
  civic_and_social_organization: 26,
  sports_and_physical_training: 27,
  real_estate: 28,
  care_services: 29,
  veterinary_and_animal_care: 30,
  entertainment: 31,
  fashion_and_cosmetics: 32,
  music: 33,
};

export const enneagramWings = [
  {
    section: "theadvocate",
    wings: ["thecollaborator", "themediator"],
  },
  {
    section: "thecollaborator",
    wings: ["theadvocate", "theentrepreneur"],
  },
  {
    section: "theentrepreneur",
    wings: ["thecollaborator", "themaverick"],
  },
  {
    section: "themaverick",
    wings: ["theentrepreneur", "theinspector"],
  },
  {
    section: "theinspector",
    wings: ["themaverick", "thestalwart"],
  },
  {
    section: "thestalwart",
    wings: ["theinspector", "theadmirer"],
  },
  {
    section: "theadmirer",
    wings: ["thestalwart", "thedefier"],
  },
  {
    section: "thedefier",
    wings: ["theadmirer", "themediator"],
  },
  {
    section: "themediator",
    wings: ["theadvocate", "thedefier"],
  },
];
export const enneagramDisplayTraits = (title) => {
  const enneagramNames = {
    theadvocate: "The Advocate",
    thecollaborator: "The Collaborator",
    theentrepreneur: "The Entrepreneur",
    themaverick: "The Maverick",
    theinspector: "The Inspector",
    thestalwart: "The Stalwart",
    theadmirer: "The Admirer",
    thedefier: "The Defier",
    themediator: "The Mediator",
  };

  return enneagramNames[title?.toLowerCase()] || title; // Return formatted name or fallback
};
export const enneagramChartConfiguration = {
  labels: [
    "theadvocate",
    "thecollaborator",
    "theentrepreneur",
    "themaverick",
    "theinspector",
    "thestalwart",
    "theadmirer",
    "thedefier",
    "themediator",
  ],
  colors: {
    theadvocate: "rgba(255, 99, 132, 0.8)",
    thecollaborator: "rgba(54, 162, 235, 0.8)",
    theentrepreneur: "rgba(255, 206, 86, 0.8)",
    themaverick: "rgba(75, 192, 192, 0.8)",
    theinspector: "rgba(153, 102, 255, 0.8)",
    thestalwart: "rgba(255, 159, 64, 0.8)",
    theadmirer: "rgba(201, 203, 207, 0.8)",
    thedefier: "rgba(123, 239, 178, 0.8)",
    themediator: "rgba(250, 128, 114, 0.8)",
  },
};

export const filterEnneagramTraitsAndGenerateKey = (
  contentKey,
  userTraits,
  enneagramWings,
) => {
  // Find the primary wings based on the contentKey
  const primaryWings = enneagramWings?.find(
    (wing) => wing?.section === contentKey,
  );

  // Filter user traits that match the primary wings
  const filterWings = userTraits?.filter((item) => {
    return primaryWings?.wings.includes(item?.trait?.title);
  });

  // Generate content key for the filtered wings
  const filterPrimaryWings = generateContentKeyForEnneagram(filterWings);

  const filterSecondaryWings = primaryWings?.wings
    .filter((item) => {
      // Check if the item is NOT included in filterPrimaryWings
      return !filterPrimaryWings.includes(item);
    })
    .join(", ");

  // Return the filtered traits and the generated content key
  return {
    primaryWings: filterPrimaryWings,
    secondaryWings: filterSecondaryWings,
  };
};

export const generateContentKeyForEnneagram = (USER_TRAITS) => {
  if (USER_TRAITS.length === 0) return "";

  // Find the maximum score
  const maxScore = Math.max(...USER_TRAITS.map((trait) => trait.score));

  // Filter traits that have the maximum score
  const maxScoreTraits = USER_TRAITS.filter(
    (trait) => trait.score === maxScore,
  );

  // If there are multiple traits with the same max score, find the one with the highest rank
  const highestRankTrait = maxScoreTraits.reduce((prev, current) => {
    // Compare ranks using the enneagramRank object
    return enneagramRank[prev.trait.title] < enneagramRank[current.trait.title]
      ? prev
      : current;
  });

  // Return the title of the trait with the highest rank
  return highestRankTrait.trait.title;
};

export const generateContentKeyForAssessment = (USER_TRAITS, assessmentId) => {
  if (USER_TRAITS.length === 0) return "";

  // Find the maximum score
  const maxScore = Math.max(...USER_TRAITS.map((trait) => trait.score));

  // Filter traits that have the maximum score
  const maxScoreTraits = USER_TRAITS.filter(
    (trait) => trait.score === maxScore,
  );

  let highestRankTrait;

  // Check the assessmentId to determine which logic to apply
  if (
    assessmentId.toLowerCase() === ENNEAGRAM_TEST_ASSESSMENT_ID.toLowerCase()
  ) {
    // If there are multiple traits with the same max score, find the one with the highest rank
    highestRankTrait = maxScoreTraits.reduce((prev, current) => {
      // Compare ranks using the enneagramRank object
      return enneagramRank[prev.trait.title] <
        enneagramRank[current.trait.title]
        ? prev
        : current;
    });

    // Return the title of the trait with the highest rank
    return highestRankTrait.trait.title;
  } else if (
    assessmentId.toLowerCase() ===
    CAREER_PREFERENCE_TEST_ASSESSMENT_ID.toLowerCase()
  ) {
    // Logic for Career Preference Test
    highestRankTrait = maxScoreTraits.reduce((prev, current) => {
      // Compare ranks using the CareerPreferenceRank object
      return CareerPreferenceRank[prev.trait.title] <
        CareerPreferenceRank[current.trait.title]
        ? prev
        : current;
    });

    // Return the title of the trait with the highest rank
    return highestRankTrait.trait.title;
  }

  // If the assessmentId does not match any known IDs, return an empty string or handle accordingly
  return "";
};

export const getABTestId = () => {
  const abTestId = {
    gatewayABTestId: "B2D0A139-AE13-42FA-906C-B24CD3082E84",
  };
  return abTestId.gatewayABTestId;
};

export const getGateway = (caseIndex) => {
  const WorldPay_RB = {
    DEVELOPMENT: "gw_16BjjoSgt6UxO3B1n",
    QA: "gw_16BjjoSgt6UxO3B1n",
    STAGING: "gw_AzZN47TLw9FdW16y1",
    PRODUCTION: "gw_AzZN47TLw9FdW16y1",
  };
  const RBCheckoutcomrathunas = {
    DEVELOPMENT: "gw_AzqgoORrOIoRK3vm",
    QA: "gw_AzqgoORrOIoRK3vm",
    STAGING: "gw_16BVLPTFEaZEcFNYs",
    PRODUCTION: "gw_16BVLPTFEaZEcFNYs",
  };
  const RBCheckoutRathunas3ds = {
    DEVELOPMENT: "gw_AzqgoORrPWu3xCoP",
    QA: "gw_AzqgoORrPWu3xCoP",
    STAGING: "gw_Azq9YyTf3P8zU41Ka",
    PRODUCTION: "gw_Azq9YyTf3P8zU41Ka",
  };
  switch (caseIndex) {
    case 1:
      return WorldPay_RB[currentEnv];

    case 2:
      return RBCheckoutcomrathunas[currentEnv];

    case 3:
      return RBCheckoutRathunas3ds[currentEnv];

    default:
      return "";
  }
};

export const downloadCounter = 10;

export const defaultIPAddress = "40.80.156.205";
export const defaultCountryCode = "US";
export const defaultCurrencyCode = "USD";
export const dashboardSettingPageURl = true;
//export const googleScore = 0.4;
export const site_key = "6Lf5G3wmAAAAAGtoQk-IVo7wCIMFwk3dWIWFsKhU";

export const googleScore = () => {
  const score = {
    DEVELOPMENT: 0.0,
    QA: 0.0,
    STAGING: 0.0,
    PRODUCTION: 0.0,
  };
  return score[currentEnv];
};
// export const createUpdateDocumentUpload = () => {
//   var numberOfDocumentUploaded = readCookie("documentUploaded")
//     ? parseInt(readCookie("documentUploaded"))
//     : 0;
//   numberOfDocumentUploaded = numberOfDocumentUploaded + 1;
//   if (numberOfDocumentUploaded == 1) {
//     var date = new Date();
//     date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
//     createCookie("uploadexpiretime", date.toGMTString(), 1);
//     createCookie("documentUploaded", numberOfDocumentUploaded, 1);
//   } else {
//     updateUploadDocCookie("documentUploaded", numberOfDocumentUploaded);
//   }
// };
export const monthlyLimitedCategory = [
  "MROW000",
  "MROW195",
  "MSBRW95",
  "MSMBROW",
];
export const monthlyFullAccessategory = [
  "M0SMB00",
  "MSMB195",
  "M000000",
  "M000195",
];

export const cardType3ds = () => {
  const cardType = {
    QA: "discover",
    PRODUCTION: "discover",
    STAGING: "discover",
    DEVELOPMENT: "discover",
  };
  return cardType[currentEnv];
};
export const GigWorkersWelcomeEmailSubject =
  "Claim up to $32,220 in Tax Credits and Receive It Within 10 Days!";
export const GigWorkersWelcomeEmailDelayMinutes = 60;
export const GigWorkersWelcomeEmailLink =
  "https://www.gigworkersolutions.com/?source=sf-iera9iac";
export const GigWorkersEnable = true;
export const WelcomeEmailTemplateId = "9E815D62-4AA7-4989-8817-6532AD29CA93";
export const GigWorkerUserSignUpEvent = {
  TemplateId: "9E815D62-4AA7-4989-8817-6532AD29CA93",
  EmailProvider: "SendGrid",
  TopicName: "emailengine",
  EventSubType: "Email",
  EventType: "DSBD",
};

export const isPaymentMSEnable = () => {
  const isPaymentMSEnable = {
    QA: true,
    PRODUCTION: true,
    STAGING: true,
    DEVELOPMENT: true,
  };
  return isPaymentMSEnable[currentEnv];
};

export const FacebookAppId = "472061225605097";
export const AppleCliendId = "com.Insightfultraits.myapp.login"; // TODO: Replace with {TEAM_ID}.{SERVICE_ID}, e.g. "ABC123DEF.com.insightfultraits.web.signin"
// export const AppleRedirectUrl =
//   "https://3ab5-2405-201-3019-10b2-6d3b-f9a3-d898-b93e.ngrok-free.app/auth/apple/callback";
export const AppleRedirectUrl =
  "https://test.insightfultraits.com/auth/apple/callback";

export const IsSingleLoginAPPEnable = () => {
  const isLoginAPPEnable = {
    PRODUCTION: true,
    STAGING: true,
    QA: true,
    DEVELOPMENT: false,
  };
  var isSingleLoginAPP = readCookie("slaenable");
  if (isSingleLoginAPP === "true" || isSingleLoginAPP === true) {
    return true;
  } else if (isLoginAPPEnable[currentEnv] === true) {
    return true;
  } else {
    return false;
  }
  //return isLoginAPPEnable[currentEnv];
};

export const getTokenExIframeJs = () => {
  const tokenExJS = {
    QA: `https://insightfulplatform.blob.core.windows.net/cdn/assets/js/tokenEXscript.js?sv=2023-01-03&st=2024-08-05T06%3A39%3A14Z&se=2050-12-25T06%3A39%3A00Z&sr=c&sp=rl&sig=vA%2FPOjLXtBXbm8aaHgpuvaoVlByr%2BhaZ6Hiqxnxnapk%3D`,
    PRODUCTION: `https://insightfulplatformprod.blob.core.windows.net/cdn/assets/js/tokenEXscript.js?sv=2023-01-03&st=2024-09-21T07%3A12%3A32Z&se=2123-12-22T07%3A12%3A00Z&sr=c&sp=rl&sig=xTTTt59cNY3ET9wc3Pj%2BE%2BO27dDUc059ItsSVAKtcAw%3D`,
    STAGING: `https://insightfulplatformprod.blob.core.windows.net/cdn/assets/js/tokenEXscript.js?sv=2023-01-03&st=2024-09-21T07%3A12%3A32Z&se=2123-12-22T07%3A12%3A00Z&sr=c&sp=rl&sig=xTTTt59cNY3ET9wc3Pj%2BE%2BO27dDUc059ItsSVAKtcAw%3D`,
    DEVELOPMENT: `https://insightfulplatform.blob.core.windows.net/cdn/assets/js/tokenEXscript.js?sv=2023-01-03&st=2024-08-05T06%3A39%3A14Z&se=2050-12-25T06%3A39%3A00Z&sr=c&sp=rl&sig=vA%2FPOjLXtBXbm8aaHgpuvaoVlByr%2BhaZ6Hiqxnxnapk%3D`,
  };
  return tokenExJS[currentEnv];
};

export const capitalizeFirstLetter = (string) => {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const PERSONALITY_TEST_ASSESSMENT_ID =
  "2faff0c7-50a3-4827-baa1-cc70892fa9f2";

export const BIG_FIVE_TEST_ASSESSMENT_ID =
  "5f7b7cfe-2909-4b7f-872e-8694d6eeba7a";

export const BIG_FIVE_FACETS_TEST_ASSESSMENT_ID =
  "c0a19fec-b7e9-4a62-b7a9-bf0e14cc9a60";

export const ENNEAGRAM_TEST_ASSESSMENT_ID =
  "15f84d33-674b-4c94-9dde-679ee35e5e3e";

export const LIKEABILITY_TEST_ASSESSMENT_ID =
  "a6cdaff9-c5aa-4b3a-986a-e921a6f4b039";

export const FOUR_TEMPERAMENTS_PERSONALITY_TEST_ASSESSMENT_ID =
  "14fdbd79-20fa-4bbc-9ddd-41154e05c50f";

export const DISC_TEST_ASSESSMENT_ID = "53f74b1a-5fa7-4e47-bccf-8c2e58665cfb";

export const ROMANTIC_COMPATIBILITY_ASSESSMENT_ID =
  "36a83d0c-3ffa-49ce-aa4f-cddb506f3849";

export const EMOTIONAL_INTELLIGENCE_TEST_ASSESSMENT_ID =
  "ef64c4ee-8a5e-437b-af4a-bb4c64058e4e";

export const DIFFICULT_PERSON_TEST_ASSESSMENT_ID =
  "8ac26067-d34a-4555-ac67-91a66302c592";

export const AUTISM_SPECTRUM_TEST_ASSESSMENT_ID =
  "c091c6ff-efad-47a9-9361-b8348ac04374";

export const HIGHLY_SENSITIVE_PERSON_TEST_ASSESSMENT_ID =
  "74360864-de6f-4efb-973a-b079f6c102c5";
export const ATTACHMENT_STYLE_TEST_ASSESSMENT_ID =
  "094ce345-33d3-4fb7-b83b-2c936c27f68a";

export const PERSONALITY_DISORDER_TEST_ASSESSMENT_ID =
  "01566bbd-c926-4e41-a4be-3a805c9aa144";

export const CAREER_PREFERENCE_TEST_ASSESSMENT_ID =
  "4e72fc41-98fa-4833-8009-98899478caa2";

export const DYSLEXIA_SCREENING_CHILDREN_TEST_ASSESSMENT_ID =
  "6a3ee87e-b813-4f88-9112-87cad5ec3442";

export const DYSLEXIA_SCREENING_ADULT_TEST_ASSESSMENT_ID =
  "f36d99da-24df-4733-978b-42162c8ffa8a";

export const ADHD_TEST_ASSESSMENT_ID = "848ec3d6-46b6-4da5-81b8-27b8dea2172c";

export const LOVE_STYLE_TEST_ASSESSMENT_ID =
  "7b9dba34-4dbb-4d66-ae15-9f24b32f21c6";

export const NARCISSISTIC_PERSONALITY_DISORDER_ASSESSMENT_ID =
  "4fef133f-15b7-4f0a-9093-b8c4392df684";

export const ANTISOCIAL_PERSONALITY_DISORDER_ASSESSMENT_ID =
  "25c9b45f-2fca-4016-8170-5388c7e28280";

export const CAREER_TEST_ASSESSMENT_ID = "a2181cc3-3772-453c-bcee-9e650213fb8a";

export const COLOR_BLINDNESS_TEST_ASSESSMENT_ID =
  "b3af8311-46ea-4411-936f-2fa562834273";
export const DEPRESSION_TEST_ASSESSMENT_ID =
  "a4b88654-1c09-45af-8972-8c938a7223b3";
export const BIPOLAR_DISORDER_ASSESSMENT_ID =
  "ce519758-b424-488e-af59-aaf0edea7d1b";

export const CHECKOUT_AB_TEST_ID = "1BD0E8CB-AB83-48DA-95AC-58EE2AE8C685";

export const DASHBOARD_AB_TEST_ID = "1359A0B6-EC2F-48F4-9452-42C582489CF0";

export const FALSE_PLAN_MAX_USER_COUNT = 3;

export const COUNTRY_CODE = {
  USA: "US",
  UK: "GB",
  CANADA: "CA",
  INDIA: "IN",
};

// export const cdnUrl = () => {
//   const cdnUrl = {
//     QA: "https://insightfulplatform.blob.core.windows.net/cdn",
//     PRODUCTION: "https://insightfulplatformprod.blob.core.windows.net/cdn",
//     STAGING: "https://insightfulplatformprod.blob.core.windows.net/cdn",
//     DEVELOPMENT: "https://insightfulplatform.blob.core.windows.net/cdn",
//   };
//   return cdnUrl[currentEnv];
// };

// Common CDN base per environment
const azureBlobUrl = {
  QA: "https://insightfulplatform.blob.core.windows.net",
  PRODUCTION: "https://insightfulplatformprod.blob.core.windows.net",
  STAGING: "https://insightfulplatformprod.blob.core.windows.net",
  DEVELOPMENT: "https://insightfulplatform.blob.core.windows.net",
};

// CDN Sign utility
export const cdnUrl = () => {
  return `${azureBlobUrl[currentEnv]}/cdn`;
};

export const cdnBaseUrl = () => {
  return azureBlobUrl[currentEnv];
};

// Blob utility
const CONTENT_PATH = "content/assessments/images";

export const contentPathUrl = () => {
  return `${azureBlobUrl[currentEnv]}/${CONTENT_PATH}/`;
};

export const cdnSign = () => {
  const cdnSign = {
    QA: `?sv=2023-01-03&st=2024-08-05T06%3A39%3A14Z&se=2050-12-25T06%3A39%3A00Z&sr=c&sp=rl&sig=vA%2FPOjLXtBXbm8aaHgpuvaoVlByr%2BhaZ6Hiqxnxnapk%3D`,
    PRODUCTION: `?sv=2023-01-03&st=2024-09-21T07%3A12%3A32Z&se=2123-12-22T07%3A12%3A00Z&sr=c&sp=rl&sig=xTTTt59cNY3ET9wc3Pj%2BE%2BO27dDUc059ItsSVAKtcAw%3D`,
    STAGING: `?sv=2023-01-03&st=2024-09-21T07%3A12%3A32Z&se=2123-12-22T07%3A12%3A00Z&sr=c&sp=rl&sig=xTTTt59cNY3ET9wc3Pj%2BE%2BO27dDUc059ItsSVAKtcAw%3D`,
    DEVELOPMENT: `?sv=2023-01-03&st=2024-08-05T06%3A39%3A14Z&se=2050-12-25T06%3A39%3A00Z&sr=c&sp=rl&sig=vA%2FPOjLXtBXbm8aaHgpuvaoVlByr%2BhaZ6Hiqxnxnapk%3D`,
  };
  return cdnSign[currentEnv];
};

export const MODEL_TYPE_DASHBOARD = {
  [LOCALE.EN]: "dashboardhome",
  [LOCALE.ES]: "dashboardhome_ES",
  [LOCALE.JA]: "dashboardhome_JA",
};

export const MODEL_TYPE_CAREER_CONTENT = {
  [LOCALE.EN]: "CareerFieldPreContentModel",
  [LOCALE.ES]: "CareerFieldPreContentModel_ES",
  [LOCALE.JA]: "CareerFieldPreContentModel_JA",
};

export const MODEL_TYPE_BIG_FIVE = {
  [LOCALE.EN]: "BigFivePersonalityTypeModel",
  [LOCALE.ES]: "BigFivePersonalityTypeModel_ES",
  [LOCALE.JA]: "BigFivePersonalityTypeModel_JA",
};

export const MODEL_TYPE_BIG_FIVE_FACETS = {
  [LOCALE.EN]: "BigFiveFacetsTypeModel",
  [LOCALE.ES]: "BigFiveFacetsTypeModel_ES",
  [LOCALE.JA]: "BigFiveFacetsTypeModel_JA",
};

export const MODEL_TYPE_ENNEAGRAM = {
  [LOCALE.EN]: "EnneagramTypeModel",
  [LOCALE.ES]: "EnneagramTypeModel_ES",
  [LOCALE.JA]: "EnneagramTypeModel_JA",
};

export const MODEL_TYPE_DIFFICULT_PERSON = {
  [LOCALE.EN]: "DifficultpersonTypeModel",
  [LOCALE.ES]: "DifficultpersonTypeModel_ES",
  [LOCALE.JA]: "DifficultpersonTypeModel_JA",
};

export const MODEL_TYPE_CAREER_PREFERENCE = {
  [LOCALE.EN]: "CareerTasksTypeModel",
  [LOCALE.ES]: "CareerTasksTypeModel_ES",
  [LOCALE.JA]: "CareerTasksTypeModel_JA",
};

export const MODEL_TYPE_EMOTIONAL_INTELLIGENCE = {
  [LOCALE.EN]: "EmotionalIntelligenceTypeModel",
  [LOCALE.ES]: "EmotionalIntelligenceTypeModel_ES",
  [LOCALE.JA]: "EmotionalIntelligenceTypeModel_JA",
};

export const MODEL_TYPE_FOUR_TEMPERAMENT = {
  [LOCALE.EN]: "FourTemperamentsTypeModel",
  [LOCALE.ES]: "FourTemperamentsTypeModel_ES",
  [LOCALE.JA]: "FourTemperamentsTypeModel_JA",
};

export const MODEL_TYPE_ADHD = {
  [LOCALE.EN]: "AdhdTypeModel",
  [LOCALE.ES]: "AdhdTypeModel_ES",
  [LOCALE.JA]: "AdhdTypeModel_JA",
};

export const MODEL_TYPE_DISC = {
  [LOCALE.EN]: "DISCTypeModel",
  [LOCALE.ES]: "DISCTypeModel_ES",
  [LOCALE.JA]: "DISCTypeModel_JA",
};

export const MODEL_TYPE_LIKEABILITY = {
  [LOCALE.EN]: "LikeabilityTypeModel",
  [LOCALE.ES]: "LikeabilityTypeModel_ES",
  [LOCALE.JA]: "LikeabilityTypeModel_JA",
};

export const MODEL_TYPE_PERSONALITY_DISORDER = {
  [LOCALE.EN]: "PersonalitydisorderTypeModel",
  [LOCALE.ES]: "PersonalitydisorderTypeModel_ES",
  [LOCALE.JA]: "PersonalitydisorderTypeModel_JA",
};

export const MODEL_TYPE_AUTISM_SPECTRUM = {
  [LOCALE.EN]: "AutismadultsTypeModel",
  [LOCALE.ES]: "AutismadultsTypeModel_ES",
  [LOCALE.JA]: "AutismadultsTypeModel_JA",
};
export const MODEL_TYPE_ATTACHMENT_STYLE = {
  [LOCALE.EN]: "AttachmentTypeModel",
  [LOCALE.ES]: "AttachmentTypeModel_ES",
  [LOCALE.JA]: "AttachmentTypeModel_JA",
};
export const MODEL_TYPE_LOVE_STYLE = {
  [LOCALE.EN]: "LovestyleTypeModel",
  [LOCALE.ES]: "LovestyleTypeModel_ES",
  [LOCALE.JA]: "LovestyleTypeModel_JA",
};
export const MODEL_TYPE_NARCISSISTIC_PERSONALITY_DISORDER = {
  [LOCALE.EN]: "NarcissisticTypeModel",
  [LOCALE.ES]: "NarcissisticTypeModel_ES",
  [LOCALE.JA]: "NarcissisticTypeModel_JA",
};
export const MODEL_TYPE_ANTISOCIAL_PERSONALITY_DISORDER = {
  [LOCALE.EN]: "AntisocialTypeModel",
  [LOCALE.ES]: "AntisocialTypeModel_ES",
  [LOCALE.JA]: "AntisocialTypeModel_JA",
};

export const MODEL_TYPE_HIGHLY_SENSITIVE_PERSON = {
  [LOCALE.EN]: "HighlysensitivepersonTypeModel",
  [LOCALE.ES]: "HighlysensitivepersonTypeModel_ES",
  [LOCALE.JA]: "HighlysensitivepersonTypeModel_JA",
};

export const MODEL_TYPE_DYSLEXIA_SCREENING_CHILDREN = {
  [LOCALE.EN]: "DyslexiachildrenTypeModel",
  [LOCALE.ES]: "DyslexiachildrenTypeModel_ES",
  [LOCALE.JA]: "DyslexiachildrenTypeModel_JA",
};

export const MODEL_TYPE_DYSLEXIA_SCREENING_ADULT = {
  [LOCALE.EN]: "DyslexiaadultsTypeModel",
  [LOCALE.ES]: "DyslexiaadultsTypeModel_ES",
  [LOCALE.JA]: "DyslexiaadultsTypeModel_JA",
};

export const CONTENT_KEY_BIG_FIVE = "ALL_CONTENT";

export const MODEL_TYPE_CAREER = {
  [LOCALE.EN]: "CareerFieldTypeModel",
  [LOCALE.ES]: "CareerFieldTypeModel_ES",
  [LOCALE.JA]: "CareerFieldTypeModel_JA",
};

export const MODEL_ROMANTIC_PERSONALIZED = {
  [LOCALE.EN]: "RomanticCompatibilityPersonalTypeModel",
  [LOCALE.ES]: "RomanticCompatibilityPersonalTypeModel_ES",
  [LOCALE.JA]: "RomanticCompatibilityPersonalTypeModel_JA",
};
export const MODEL_ROMANTIC_COMPATIBILITY = {
  [LOCALE.EN]: "RomanticCompatibilityTypeModel",
  [LOCALE.ES]: "RomanticCompatibilityTypeModel_ES",
  [LOCALE.JA]: "RomanticCompatibilityTypeModel_JA",
};

export const MODEL_TYPE_COLOR_BLIND = {
  [LOCALE.EN]: "ColorBlindTypeModel",
  [LOCALE.ES]: "ColorBlindTypeModel_ES",
  [LOCALE.JA]: "ColorBlindTypeModel_JA",
};

export const MODEL_TYPE_DEPRESSION = {
  [LOCALE.EN]: "DepressionTypeModel",
  [LOCALE.ES]: "DepressionTypeModel_ES",
  [LOCALE.JA]: "DepressionTypeModel_JA",
};

export const MODEL_TYPE_BIPOLAR_DISORDER = {
  [LOCALE.EN]: "BipolarDisorderTypeModel",
  [LOCALE.ES]: "BipolarDisorderTypeModel_ES",
  [LOCALE.JA]: "BipolarDisorderTypeModel_JA",
};

export const planPageABTestID = "1175D61E-5EB6-41DE-A0AE-FF35F4C3B6DB";

export const plan1995 = "MAB1995";

export const noTestImage = () => {
  const noTestImage = {
    QA: `https://insightfulplatform.blob.core.windows.net/cdn/assets/images/no-test-image.svg?sv=2023-01-03&st=2024-08-05T06%3A39%3A14Z&se=2050-12-25T06%3A39%3A00Z&sr=c&sp=rl&sig=vA%2FPOjLXtBXbm8aaHgpuvaoVlByr%2BhaZ6Hiqxnxnapk%3D`,
    PRODUCTION: `https://insightfulplatformprod.blob.core.windows.net/cdn/assets/images/no-test-image.svg?sv=2023-01-03&st=2024-09-21T07%3A12%3A32Z&se=2123-12-22T07%3A12%3A00Z&sr=c&sp=rl&sig=xTTTt59cNY3ET9wc3Pj%2BE%2BO27dDUc059ItsSVAKtcAw%3D`,
    STAGING: `https://insightfulplatformprod.blob.core.windows.net/cdn/assets/images/no-test-image.svg?sv=2023-01-03&st=2024-09-21T07%3A12%3A32Z&se=2123-12-22T07%3A12%3A00Z&sr=c&sp=rl&sig=xTTTt59cNY3ET9wc3Pj%2BE%2BO27dDUc059ItsSVAKtcAw%3D`,
    DEVELOPMENT: `https://insightfulplatform.blob.core.windows.net/cdn/assets/images/no-test-image.svg?sv=2023-01-03&st=2024-08-05T06%3A39%3A14Z&se=2050-12-25T06%3A39%3A00Z&sr=c&sp=rl&sig=vA%2FPOjLXtBXbm8aaHgpuvaoVlByr%2BhaZ6Hiqxnxnapk%3D`,
  };
  return noTestImage[currentEnv];
};

export const getBigFiveTraitResultCode = (score, traitCode) => {
  if (!score || !traitCode || score < 1 || score > 5) {
    return "Invalid input";
  }

  const scoreRanges = [
    { upper: 5, lower: 4.6, suffix: "_H" },
    { upper: 4.6, lower: 3.53, suffix: "_AA" },
    { upper: 3.53, lower: 2.47, suffix: "_A" },
    { upper: 2.47, lower: 1.4, suffix: "_BA" },
    { upper: 1.4, lower: 1, suffix: "_L" },
  ];

  // const validTraits = new Set(["E", "A", "O", "C", "N"]);
  // if (!validTraits.has(traitCode)) {
  //   return `Invalid trait code: ${traitCode}`;
  // }
  // Adjust the range check to include `score === 1`
  const matchingRange = scoreRanges.find((range) =>
    range.lower === 1
      ? score <= range.upper && score >= range.lower
      : score <= range.upper && score > range.lower
  );

  // const matchingRange = scoreRanges.find(
  //   (range) => score <= range.upper && score > range.lower
  // );

  return matchingRange
    ? `${traitCode}${matchingRange.suffix}`
    : `No matching result found for score: ${score}`;
};

export const BIG_FIVE_TRAITS_LONG_NAME = {
  E: "Extraversion",
  O: "Openness",
  A: "Agreeableness",
  C: "Conscientiousness",
  N: "Neuroticism",
};

export const traitTitleKeyMap = {
  [LOCALE.EN]: "title",
  [LOCALE.ES]: "title_ES",
  [LOCALE.JA]: "title_JA",
};

export const traitNameKeyMap = {
  [LOCALE.EN]: "name",
  [LOCALE.ES]: "name_ES",
  [LOCALE.JA]: "name_JA",
};

export const labelKeyMap = {
  [LOCALE.EN]: "label",
  [LOCALE.ES]: "label_ES",
  [LOCALE.JA]: "label_JA",
};

export const contentSign = () => {
  const contentSign = {
    QA: `?sv=2023-01-03&si=content-readonly&sr=c&sig=8%2Bne0cJeRY7fqV6FOJmFFO4%2Bx3pAygR8KyrJ%2FJtH2OU%3D`,
    PRODUCTION: `?sv=2023-01-03&si=content-readonly&sr=c&sig=l60y4v5rQtpKKlrRPJT%2FdcAJDYPbMmT%2BUc7XjOPVaE4%3D`,
    STAGING: `?sv=2023-01-03&si=content-readonly&sr=c&sig=l60y4v5rQtpKKlrRPJT%2FdcAJDYPbMmT%2BUc7XjOPVaE4%3D`,
    DEVELOPMENT: `?sv=2023-01-03&si=content-readonly&sr=c&sig=8%2Bne0cJeRY7fqV6FOJmFFO4%2Bx3pAygR8KyrJ%2FJtH2OU%3D`,
  };
  return contentSign[currentEnv];
};

// //parameter usertraits

export const ROMANTIC_COMPATIBILITY_TRAIT_KEY_MAP = {
  communication_style: "CommunicationStyle",
  emotional_compatibility: "EmotionalCompatibility",
  lifestyle_preferences: "LifestylePreferences",
  conflict_resolution: "ConflictResolution",
  core_values_and_beliefs: "CoreValuesAndBeliefs",
  intimacy_and_affection: "IntimacyAndAffection",
  independence_vs_togetherness: "IndependenceBalance",
  financial_philosophy: "FinancialPhilosophy",
  ambition_and_growth: "AmbitionAndGrowth",
  family_and_social_dynamics: "FamilyAndSocialDynamics",
  adventure_and_exploration: "AdventureAndExploration",
  conflict_triggers: "ConflictTriggers",
};

export const getAssessmentOverviewModelType = (assessmentId) => {
  const map = {
    [BIPOLAR_DISORDER_ASSESSMENT_ID]: "BipolarDisorderTypeModel_Overview",
    [COLOR_BLINDNESS_TEST_ASSESSMENT_ID]: "ColorBlindTypeModel_Overview",
    [LOVE_STYLE_TEST_ASSESSMENT_ID]: "LoveStyleTypeModel_Overview",
    [PERSONALITY_TEST_ASSESSMENT_ID]: "PersonalityTypeModel_Overview",
    [BIG_FIVE_TEST_ASSESSMENT_ID]: "BigFiveTypeModel_Overview",
    [BIG_FIVE_FACETS_TEST_ASSESSMENT_ID]: "BigFiveFacetsTypeModel_Overview",
    [ENNEAGRAM_TEST_ASSESSMENT_ID]: "EnneagramTypeModel_Overview",
    [DIFFICULT_PERSON_TEST_ASSESSMENT_ID]: "DifficultPersonTypeModel_Overview",
    [CAREER_PREFERENCE_TEST_ASSESSMENT_ID]: "CareerTasksTypeModel_Overview",
    [EMOTIONAL_INTELLIGENCE_TEST_ASSESSMENT_ID]:
      "EmotionalIntelligenceTypeModel_Overview",
    [FOUR_TEMPERAMENTS_PERSONALITY_TEST_ASSESSMENT_ID]:
      "FourTemperamentsTypeModel_Overview",
    [ADHD_TEST_ASSESSMENT_ID]: "AdhdTypeModel_Overview",
    [DISC_TEST_ASSESSMENT_ID]: "DISCTypeModel_Overview",
    [LIKEABILITY_TEST_ASSESSMENT_ID]: "LikeabilityTypeModel_Overview",
    [PERSONALITY_DISORDER_TEST_ASSESSMENT_ID]:
      "PersonalityDisorderTypeModel_Overview",
    [AUTISM_SPECTRUM_TEST_ASSESSMENT_ID]: "AutismAdultsTypeModel_Overview",
    [ATTACHMENT_STYLE_TEST_ASSESSMENT_ID]: "AttachmentTypeModel_Overview",
    [NARCISSISTIC_PERSONALITY_DISORDER_ASSESSMENT_ID]:
      "NarcissisticTypeModel_Overview",
    [ANTISOCIAL_PERSONALITY_DISORDER_ASSESSMENT_ID]:
      "AntisocialTypeModel_Overview",
    [HIGHLY_SENSITIVE_PERSON_TEST_ASSESSMENT_ID]:
      "HighlySensitivePersonTypeModel_Overview",
    [DYSLEXIA_SCREENING_CHILDREN_TEST_ASSESSMENT_ID]:
      "DyslexiaChildrenTypeModel_Overview",
    [DYSLEXIA_SCREENING_ADULT_TEST_ASSESSMENT_ID]:
      "DyslexiaAdultsTypeModel_Overview",
    [DEPRESSION_TEST_ASSESSMENT_ID]: "DepressionTypeModel_Overview",
    [ROMANTIC_COMPATIBILITY_ASSESSMENT_ID]:
      "RomanticCompatibilityTypeModel_Overview",
    [CAREER_TEST_ASSESSMENT_ID]: "CareerFieldTypeModel_Overview",
  };

  const base = map[assessmentId];

  if (!base) return null;

  return {
    [LOCALE.EN]: base,
    [LOCALE.ES]: `${base}_ES`,
    [LOCALE.JA]: `${base}_JA`, // ✅ added JA
  };
};

export const ASSESSMENT_OVERVIEW_CONTENT_KEY = "OVERVIEW_CONTENT";

export const getCaptchaSitekeyForSignup = () => {
  const siteKeys = {
    QA: "6LdjxoEsAAAAANFnWlbgpVlco2vLBT9cOaHcR9XS",
    PRODUCTION: "6LdjxoEsAAAAANFnWlbgpVlco2vLBT9cOaHcR9XS",
    STAGING: "6LdjxoEsAAAAANFnWlbgpVlco2vLBT9cOaHcR9XS",
    DEVELOPMENT: "6LdjxoEsAAAAANFnWlbgpVlco2vLBT9cOaHcR9XS",
  };
  return siteKeys[currentEnv];
};
export const getGoogleCaptchaKey = () => {
  const siteKeys = {
    QA: "6LdjxoEsAAAAANFnWlbgpVlco2vLBT9cOaHcR9XS",
    PRODUCTION: "6LdjxoEsAAAAANFnWlbgpVlco2vLBT9cOaHcR9XS",
    STAGING: "6LdjxoEsAAAAANFnWlbgpVlco2vLBT9cOaHcR9XS",
    DEVELOPMENT: "6LdjxoEsAAAAANFnWlbgpVlco2vLBT9cOaHcR9XS",
  };
  return siteKeys[currentEnv];
};

export const invalidMailboxStatuses = ["mailbox_not_found", "no_mailbox"];

export const currentPortalCDForCaptcha = "IT";
